import axiosInstance from "./axios.instance";
// apies calls for customers

const API_GET_CUSTOMERS = async (pageNo, limit, searchText) => {
  try {
    const resp = await axiosInstance.get(
      `/admin?page=${pageNo}&limit${limit}&companyName=${searchText}`
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ADD_COMPANY = async (data) => {
  try {
    const resp = await axiosInstance.post(`/company`, data);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ADD_USER = async (data) => {
  try {
    const resp = await axiosInstance.post(`/user`, data);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ADD_SUBSCRIPTION = async (data) => {
  try {
    const resp = await axiosInstance.post(`/support/subscription`, data);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const getPlans = async () => {
  try {
    const resp = await axiosInstance.get(`/subscription-type`);
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_PUT_COMPANY_REQUEST = async (data) => {
  try {
    const resp = await axiosInstance.put(`/company`, data);
    return resp.data;
    // const resp = await axios.put(
    //   `https://developers.facebook.com/apps/1140950256592261/whatsapp-business/wa-dev-console/?business_id=683975392840248`,
    //   data
    // );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export {
  API_ADD_USER,
  API_ADD_COMPANY,
  API_GET_CUSTOMERS,
  API_ADD_SUBSCRIPTION,
  API_PUT_COMPANY_REQUEST,
  getPlans,
};
